import { useEffect, useState } from 'react';
import TableHeaderSearch from '@/components/data-table/TableHeaderSearch';
import TableHeaderSort from '@/components/data-table/TableHeaderSort';
import TableHeaderTitle from '@/components/data-table/TableHeaderTitle';
import useQueryParamsContext from '@/contexts/query-params/useQueryParamsContext';

/**
 * A column title with the app's header controls: the sort arrows (`sort` is
 * the column's sort key without the `sort` prefix, e.g. `dueDate`) and, on
 * the main column, the search over the whole list (`search`).
 */
export default function ColumnTitle({ title, sort, search = false }) {
  const { queryParams, setQueryParams } = useQueryParamsContext();
  const [term, setTerm] = useState({ search: queryParams.search || '' });
  const [open, setOpen] = useState({ search: false });

  useEffect(() => setTerm({ search: queryParams.search || '' }), [queryParams.search]);

  return (
    <TableHeaderTitle title={title}>
      {search && (
        <TableHeaderSearch
          dataIndex="search"
          title={title}
          searchTerm={term}
          toggleDropdown={open}
          onChange={(name, value) => setTerm((s) => ({ ...s, [name]: value }))}
          onClose={(name, value) => setOpen((s) => ({ ...s, [name]: value }))}
          onSubmit={(name, form) => {
            setOpen({ search: false });
            const value = String(form[name] || '').trim();
            setQueryParams({ search: value || undefined, offset: 1 });
          }}
          onReset={() => {
            setOpen({ search: false });
            setTerm({ search: '' });
            setQueryParams({ search: undefined, offset: 1 });
          }}
        />
      )}
      {sort && <TableHeaderSort dataIndex={sort} />}
    </TableHeaderTitle>
  );
}
